package com.shadowings.gero.domain.model

import org.jetbrains.compose.resources.StringResource
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

data class MultiSelectionContent @OptIn(ExperimentalUuidApi::class) constructor(
    val text: QuizText,
    val options: List<Option>,
    override val id: String = Uuid.random().toHexDashString()
) : IQuizContent, ICountableQuiz {
    // Helper constructors for StringResource and String
    constructor(text: StringResource, options: List<Option>) :
        this(QuizText.Resource(text), options)
    constructor(text: String, options: List<Option>) :
        this(QuizText.Plain(text), options)
}

